import { $window, $body } from '../../../../../../ig_template/Resources/Public/Src/Js/Constants';
import HtmlElement from '../../../../../../ig_template/Resources/Public/Src/Js/Elements/HtmlElement';

/**
 * Stores Search
 */
const StoresSearch = (() => {

	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		STORE_SEARCH: '.store-search',
		COUNTRY_FIELD: '.country-field',
		FIELD_COLUMN: '.field-column'
	};

	/**
	 * Country Ids
	 *
	 * @var { Array }
	 */
	const CountryIds = [1];

	/**
	 * Stores Search
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class StoresSearch extends HtmlElement {
		onReady() {
			this.$countryField = this.$element.find(Selector.COUNTRY_FIELD);
			this.$fieldColumns = this.$element.find(Selector.FIELD_COLUMN);

			this._checkCountry();
			this._bindHandlers();
		}

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			this.$countryField.on('change', () => {
				this._checkCountry();
			});
		}

		_checkCountry() {
			const id = parseInt(this.$countryField.val());
			const isInCountryList = CountryIds.indexOf(id) > -1;
			this._toggleForm(isInCountryList);
		}

		_toggleForm(showColumns) {
			this.$fieldColumns.toggleClass('hide', !showColumns);
			this.$fieldColumns.find('input, select').prop('required', showColumns);
			this.$fieldColumns.find('input').val('');
			this.$fieldColumns.find('select').val(showColumns ? 5 : '');
		}
	}

	return StoresSearch._getElement($body.find(Selector.STORE_SEARCH), StoresSearch);
})();

export default StoresSearch;
